"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var _decorators_1 = require("../../../_decorators");
var reports_const_1 = require("./reports.const");
var ReportsService = /** @class */ (function () {
    function ReportsService() {
    }
    /**
     * Returns a list of reports groups
     * @param version {string}
     * @returns {Promise<ReportGroupResponse[]>}
     */
    ReportsService.prototype.getReportGroups = function (version) {
        if (version === void 0) { version = 'v1'; }
        var url = reports_const_1.REPORTS_ENDPOINTS.getReportGroups
            .replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns a single report
     * @param {string} reportUuid
     * @param {string} version
     * @returns {Promise<ReportResponse>}
     */
    ReportsService.prototype.getReport = function (reportUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = reports_const_1.REPORTS_ENDPOINTS.getReport
            .replace('{{version}}', version)
            .replace('{{reportUuid}}', reportUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Adds a report
     * @param {ReportRequest} data
     * @param version {string}
     * @returns {Promise<ReportResponse>}
     */
    ReportsService.prototype.postReport = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = reports_const_1.REPORTS_ENDPOINTS.postReport
            .replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Updates the given report
     * @param {string} reportUuid - Identifier
     * @param {ReportRequest} data
     * @param version {string}
     * @returns {Promise<ReportResponse>}
     */
    ReportsService.prototype.patchReport = function (reportUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = reports_const_1.REPORTS_ENDPOINTS.patchReport
            .replace('{{version}}', version)
            .replace('{{reportUuid}}', reportUuid);
        return axios_client_service_1.axiosClientInstance.patch(url, data);
    };
    /**
     * Deletes the given report
     * @param {string} reportUuid - Identifier
     * @param version {string}
     * @returns {Promise<any>}
     */
    ReportsService.prototype.deleteReport = function (reportUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = reports_const_1.REPORTS_ENDPOINTS.deleteReport
            .replace('{{version}}', version)
            .replace('{{reportUuid}}', reportUuid);
        return axios_client_service_1.axiosClientInstance.delete(url);
    };
    /**
     * Returns the timestamp of the server to sign the reports
     * @returns {Promise<any>}
     */
    ReportsService.prototype.getRealTimestamp = function () {
        var url = reports_const_1.REPORTS_ENDPOINTS.getRealTimestamp;
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    tslib_1.__decorate([
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], ReportsService.prototype, "getReportGroups", null);
    tslib_1.__decorate([
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String, Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], ReportsService.prototype, "getReport", null);
    tslib_1.__decorate([
        _decorators_1.snakeCaseRequest,
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], ReportsService.prototype, "postReport", null);
    tslib_1.__decorate([
        _decorators_1.snakeCaseRequest,
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String, Object, Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], ReportsService.prototype, "patchReport", null);
    tslib_1.__decorate([
        _decorators_1.camelCaseResponse,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", []),
        tslib_1.__metadata("design:returntype", Promise)
    ], ReportsService.prototype, "getRealTimestamp", null);
    return ReportsService;
}());
/**
 * ReportService Class Instance
 * @namespace
 */
exports.reports = new ReportsService();
